import React from "react";
import { AlertTriangle, ArrowRight } from "lucide-react";

function ageLabel(iso) {
  if (!iso) return null;
  const hours = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 3600000));
  if (hours < 1) return "under an hour";
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
}

export function RefundQueueCard({ queue, active, onShow }) {
  if (!queue || !queue.count) return null;
  const age = ageLabel(queue.oldest_at);
  return (
    <div
      className="mb-5 rounded-2xl border border-rose-200 bg-rose-50 p-5 flex flex-col sm:flex-row sm:items-center gap-4"
      data-testid="refund-queue-card"
    >
      <div className="h-11 w-11 shrink-0 rounded-xl bg-rose-600 text-white flex items-center justify-center">
        <AlertTriangle size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-[11px] uppercase tracking-widest font-bold text-rose-700">Refunds pending</p>
        <p className="mt-1 text-2xl font-extrabold text-rose-900" style={{ fontFamily: "Poppins" }} data-testid="refund-queue-count">
          {queue.count} consultation{queue.count === 1 ? "" : "s"} · ₹{queue.total_amount.toLocaleString("en-IN")}
        </p>
        <p className="mt-1 text-xs text-rose-800/80" data-testid="refund-queue-hint">
          Paid by the client, but {queue.by_status?.rejected ? `${queue.by_status.rejected} rejected by the lawyer` : ""}
          {queue.by_status?.rejected && queue.by_status?.lawyer_no_show ? " and " : ""}
          {queue.by_status?.lawyer_no_show ? `${queue.by_status.lawyer_no_show} closed as lawyer no-show` : ""} — refund not yet issued.
          {age && <> Oldest waiting {age}.</>}
        </p>
      </div>
      <button
        type="button"
        onClick={onShow}
        disabled={active}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold bg-rose-600 text-white hover:bg-rose-700 disabled:opacity-60 disabled:cursor-default"
        data-testid="refund-queue-show-btn"
      >
        {active ? "Showing pending refunds" : "Show pending refunds"}
        {!active && <ArrowRight size={14} />}
      </button>
    </div>
  );
}
